<template>
  <div>
    <v-container fluid>
      <v-card
        elevation="0"
        class="ma-0 pb-3"
        :loading="$apollo.queries.getAdminContract.loading"
      >
        <v-card-title class="secondary--text font-weight-medium pt-5 pb-0">
          <v-row class="ma-0">
            <h3 class="my-2 primary--text">
              {{ $t("contract.defaultContract") }}
            </h3>
          </v-row>
        </v-card-title>

        <v-row class="px-3">
          <v-col cols="6">
            <v-card flat>
              <v-card-title class="py-2 text-body-2 pl-0"> </v-card-title>
              <vue-editor ref="contractEn" />
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card flat>
              <v-card-title class="py-2 text-body-2 pl-0"> </v-card-title>

              <vue-editor ref="contractAr" />
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="contractValues.compulsoryVacatePeriod"
              v-bind="vacatedPeriodAttr"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center" class="py-3">
          <v-col cols="4">
            <v-btn
              :disabled="!isFormValid"
              :loading="saveLoading"
              class="white--text rounded-lg"
              color="primary"
              width="100%"
              @click="saveDefaultContract"
            >
              {{ $t("common.save") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </div>
</template>

<script>
// import AddButton from "@/core/components/AddButton.vue";
import "@/core/methods/validations.js";
import { VueEditor } from "vue2-quill-editor";

export default {
  data() {
    return {
      contractValues: {
        contractEn: null,
        contractAr: null,
        compulsoryVacatePeriod: null
      },
      saveLoading: false,
      testVariable: "testVariable"
    };
  },
  components: {
    // avatar
    // "add-button": AddButton,
    VueEditor
  },
  computed: {
    isFormValid() {
      return (
        this.contractValues.contractEn &&
        this.contractValues.contractAr &&
        this.contractValues.compulsoryVacatePeriod
      );
    },
    vacatedPeriodAttr() {
      return {
        label: this.$t("contract.defaultCompulsoryVacatePeriod"),
        outlined: true,
        dense: true
      };
    },
    contractEditors() {
      return [
        {
          title: this.$t("contract.contractEn"),
          type: "rtfEditor",
          modelMap: "contractEn",
          attrs: {}
        },
        {
          title: this.$t("contract.contractAr"),
          type: "rtfEditor",
          modelMap: "contractAr",
          attrs: {}
        },
        {
          title: null,
          type: "text",
          modelMap: "compulsoryVacatePeriod",
          attrs: {
            label: this.$t("contract.defaultCompulsoryVacatePeriod"),
            outlined: true,
            dense: true
          }
        }
      ];
    }
  },
  apollo: {
    getAdminContract() {
      return {
        query: require("@/contract/api/queries/get_contract.graphql"),
        result({ data }) {
          this.contractValues = data.getAdminContract;
          this.initializeEditors();
        }
      };
    }
  },

  methods: {
    initializeEditors() {
      // Manually set initial content to ensure both editors render properly
      this.$nextTick(() => {
        if (this.$refs.contractEn && this.$refs.contractEn.quill) {
          this.$refs.contractEn.quill.clipboard.dangerouslyPasteHTML(
            this.contractValues.contractEn
          );
        }
        if (this.$refs.contractAr && this.$refs.contractAr.quill) {
          this.$refs.contractAr.quill.clipboard.dangerouslyPasteHTML(
            this.contractValues.contractAr
          );
        }
      });
    },
    saveDefaultContract() {
      this.saveLoading = true;

      const quillInstanceEn = this.$refs.contractEn.quill;
      const enText = quillInstanceEn.root.innerHTML;
      const quillInstanceAr = this.$refs.contractAr.quill;
      const arText = quillInstanceAr.root.innerHTML;

      this.$apollo
        .mutate({
          mutation: require("@/contract/api/mutations/create_contract.graphql"),
          variables: {
            input: {
              contractEn: enText,
              contractAr: arText,
              compulsoryVacatePeriod: this.contractValues.compulsoryVacatePeriod
            }
          }
        })
        .then(({ data }) => {
          this.$root.$emit("snackbar", {
            snackbar: true,
            text: this.$t(
              data.createAdminContract
                ? "common.saveSuccess"
                : "landlord.errorOccured"
            ),
            color: data.createAdminContract ? "green" : "error"
          });
          this.saveLoading = false;
        });
    }
  },
  beforeDestroy() {
    this.$root.$off("refetchContract");
  }
};
</script>
<style scoped>
.datatable >>> .v-data-footer__select {
  direction: ltr !important;
}
.datatable >>> .v-data-footer__pagination {
  direction: ltr !important;
}
</style>
